// @ts-ignore
import { access_token, apiClient } from "../client/backendclient.js";
import { AxiosError, AxiosRequestConfig } from "axios";

export const AXIOS_INSTANCE = apiClient; // use your own URL here or environment variable

// add a second `options` argument here if you want to pass extra options to each generated query
export const useCustomInstance = <T>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> => {
  return AXIOS_INSTANCE({
    ...config,
    ...options,
    headers: {
      Authorization: "Bearer " + access_token,
    },
    // @ts-ignore
  }).then(({ data }) => data);
};

export type ErrorType<Error> = AxiosError<Error>;

export type BodyType<BodyData> = BodyData;
